import {
  ChangeDetectionStrategy,
  Component,
  effect,
  inject,
  viewChild,
} from '@angular/core'
import { TranslatePipe, TranslateService } from '@ngx-translate/core'
import { BaseModule } from 'shared/base/base.module'
import { HtButtonIntent } from 'shared/base/ht-button/ht-button.component'
import {
  HtModalComponent,
  HtModalOptions,
} from 'shared/base/ht-modal/ht-modal.component'
import { ActiveCallWarningService } from 'src/app/services/active-call-warning.service'

@Component({
  selector: 'ht-active-call-warning',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [BaseModule, TranslatePipe],
  templateUrl: './active-call-warning.component.html',
})
export class ActiveCallWarningComponent {
  readonly #warningService = inject(ActiveCallWarningService)
  readonly #translate = inject(TranslateService)

  readonly isVisible = this.#warningService.isVisible
  readonly modal = viewChild(HtModalComponent)

  readonly modalOptions: HtModalOptions

  constructor() {
    this.modalOptions = {
      title: {
        text: this.#translate.instant('shared.activeCallWarning.title'),
      },
      size: 'small',
      rightBtnArray: [
        {
          show: true,
          text: this.#translate.instant('shared.activeCallWarning.gotIt'),
          intent: HtButtonIntent.PRIMARY,
          click: () => this.onGotIt(),
        },
      ],
    }
    effect(() => {
      const modal = this.modal()
      if (!modal) {
        return
      }
      if (this.isVisible()) {
        modal.open()
      } else {
        modal.close(false)
      }
    })
  }

  onGotIt() {
    this.#warningService.hide()
  }
}
